<template>
<div>
  <h1>About</h1>
    <h3>Version Number {{ this.versionData[this.versionData.length-1].versionNo }}</h3>
    <p>About this Version: {{ this.versionData[this.versionData.length-1].description }}</p>
</div>
</template>

<script>

import versionControl from "../data/versionControl";
export default {
    data: () => ({
        versionData: versionControl,
    })
}
</script>

<style>

</style>